import { render } from "./profilePage.vue?vue&type=template&id=e3f8c510"
import script from "./profilePage.vue?vue&type=script&lang=js"
export * from "./profilePage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__